var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.4131e-06 10.5103C-1.39663e-06 10.1336 0.143844 9.7569 0.430931 9.46967L9.46947 0.431223C10.0444 -0.143741 10.9766 -0.143741 11.5514 0.431223C12.1261 1.00595 12.1261 1.93797 11.5514 2.51298L3.55357 10.5103L11.5511 18.5077C12.1258 19.0827 12.1258 20.0146 11.5511 20.5893C10.9764 21.1645 10.0442 21.1645 9.46919 20.5893L0.43065 11.551C0.143518 11.2636 -1.42956e-06 10.8869 -1.4131e-06 10.5103Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevDate);
export default __webpack_public_path__ + "static/media/prevDate.e0fdb03a36dc55759d3773c7a2045967.svg";
export { ForwardRef as ReactComponent };